import React, { useRef, useMemo, useEffect } from 'react';

import { useIsLoading, useIsFetching } from '@gogame/query';
import { useScreenDispatch, useScreenTitle } from '@gogame/screens';

const ANALYTICS_SCREEN_OPEN = 'ANALYTICS_SCREEN_OPEN';
const ANALYTICS_SCREEN_LOADED = 'ANALYTICS_SCREEN_LOADED';
const ANALYTICS_SCREEN_FETCHED = 'ANALYTICS_SCREEN_FETCHED';

export const screenWithAnalyticsAdapter =
  ({ businessKeyQuery }, BaseComponent) =>
  (props) => {
    const isScreenLoading = useIsLoading(businessKeyQuery.getPath());
    const isScreenFetching = useIsFetching(businessKeyQuery.getPath());
    const dispatch = useScreenDispatch();
    const [title] = useScreenTitle();
    const timerRef = useRef(null);

    useMemo(() => {
      timerRef.current = performance.now();
      dispatch({
        type: ANALYTICS_SCREEN_OPEN,
        payload: { screen: title },
      });
    }, []);

    useEffect(() => {
      if (!isScreenLoading) {
        const duration = Math.round(performance.now() - timerRef.current);
        dispatch({
          type: ANALYTICS_SCREEN_LOADED,
          payload: { screen: title, duration: duration },
        });
      }
    }, [isScreenLoading]);

    useEffect(() => {
      if (!isScreenFetching) {
        dispatch({
          type: ANALYTICS_SCREEN_FETCHED,
          payload: { screen: title },
        });
      }
    }, [isScreenFetching]);

    return React.createElement(BaseComponent, props);
  };
